import styled from "styled-components";
import { defaults, colors } from "../../../../styles";
export const Container = styled(defaults.Container)`
  flex: 1;
  flex-direction: row;
`;

export const YesNoLabel = styled(defaults.Label)`
  flex: 1;
  padding: 10px;
  margin: 10px;
  text-align: center;
  border-radius: 3px;
  color: ${colors.white};
  background-color: ${({ bgColor }) => bgColor};

  opacity: ${({ checked, selected }) =>
    checked || !selected ? 1 : defaults.opacityNotSelected};
`;
